export default __webpack_public_path__ + "static/media/AntyLucy_8.9dc05799.jpg";